import { Component, ViewChild, Input } from "@angular/core";
import { AgRendererComponent } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid";




@Component({
    selector: 'select-cell',
    template: `

    <select #select class="form-control ixsControl" style="border-right: none;height: 25px !important;
    border-top-right-radius: 0 !important;background: transparent !important;
    border-bottom-right-radius: 0 !important;" [(ngModel)]="value" (change)="valueChange()">
    <option *ngFor="let item of data" [value]="item[valueMember]">{{
      item[displayMember]
    }}</option>
  </select>

`,
    styleUrls: ['selectStyle.css']
})

export class GridDropDownComponent implements AgRendererComponent {

    @ViewChild('select') dropdown: any

    @Input()
    valueMember: string;

    @Input()
    displayMember: string;

    refresh(params: any): boolean {

        return true;
    }

    private params: any;

    private column: any;

    public value: any;

    public data: any;


    constructor() {

    }

    private async loadData() {
        
        this.valueMember = this.column.colDef.dataValueField;
        this.displayMember = this.column.colDef.dataDisplayField;
        this.dropdown.caption = this.column.colDef.headerName;
        
        this.data = this.column.colDef.dropdownData;
        
        this.dropdown.disabled = !Boolean(this.params.colDef.editable === undefined ? true : this.params.colDef.editable);


    }


    async agInit(params: ICellRendererParams) {

        
        this.params = params;
        this.value = this.params.value;
        this.column = this.params.column;
        
        await this.loadData();
        
        this.value = !this.value ? this.column.colDef.value : this.value
        params.node.setDataValue(this.column.colDef.field, !this.value ? this.column.colDef.value : this.value);
        

    }

    getValue(): any {
        
        return this.params.value;
    }

    valueChange() {
        
        this.params.setValue(this.value);
    }



}



// WEBPACK FOOTER //
// ./src/app/components/grid/editors/dropdown/griddropdown.component.ts